import { toast } from "sonner";
import { open as openDialog } from "@store/features/layout/dialogSlice";
import { store } from "@store/index";
import { trpc } from "@utils/api";

export const openCreateWorkspacePageDialog = async ({
  subdomain,
  title = "",
  path = "",
}: {
  subdomain: string;
  title?: string;
  path?: string;
}) => {
  try {
    const models = await trpc.crm.getModels.query();
    const workspacePageModels = models.map((model) => ({
      id: model.id,
      label: model.namePlural || model.name,
      handle: model.handle,
      handlePlural: model.handlePlural,
    }));

    if (workspacePageModels.length === 0) {
      toast.error("No models available to create a page");
      return;
    }

    store.dispatch(
      openDialog({
        schema: "CREATE_WORKSPACE_PAGE",
        params: {
          title,
          path,
          modelId: workspacePageModels[0]?.id ?? "",
          models: workspacePageModels,
          subdomain,
          autoGeneratePath: true,
        },
      }),
    );
  } catch (error) {
    toast.error(
      error instanceof Error ? error.message : "Failed to load models",
    );
  }
};
